/**
 * @name utilities
 *
 * @desc Contains useful functions to resolve bugs
 *
 */
export function Utilities() {
  /**
   * @name NewsletterFormInvalidation
   *
   * @desc This function is used to invalidate the newsletter form when another form exists.
   * In this way, we allow the event to arrive correctly in Analytics
   *
   */
   setTimeout(function () {
      if(nfForms.length > 1 && nfForms[1].settings.title.toLowerCase() === 'newsletter') {
        nfForms[1] = [];
      }
   }, 1000)
}